module.exports = __webpack_public_path__ + "static/media/tension4.39058930.webp";